export default "__VITE_ASSET__jdijejOE__"